export default "__VITE_ASSET__ba802cc7__"